/**
 * Empty state shown when no data is available for the selected level/node.
 * Provides helpful guidance to users on how to get data again.
 */
export function NoDataAtLevelState() {
  return (
    <div
      className="rounded-md border border-amber-200 bg-amber-50 p-6"
      data-testid="no-data-at-level-state"
    >
      <div className="mb-4">
        <h3 className="text-base font-semibold text-amber-900">
          No data available on the selected level
        </h3>
        <p className="mt-2 text-sm text-amber-800">
          The selected level doesn't have any data available for the current
          filters. Try selecting an ID for a different level or adjusting your
          filter settings.
        </p>
      </div>
    </div>
  );
}
